import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=3d4a0b3e&scoped=true"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"
import style0 from "./Servicos.vue?vue&type=style&index=0&id=3d4a0b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a0b3e",
  null
  
)

export default component.exports